export const offerDetailsDataTexts = {
  whatsNext: 'Что будет дальше',
};
